import type { ReactNode } from 'react';

import { Col } from '@opendoor/atoms/box';
import { Text } from '@opendoor/atoms/text';
import { cn } from '@opendoor/atoms/utils';

interface CashOfferCardProps {
  headingId: string;
  headingClassName?: string;
  children: ReactNode;
  media?: ReactNode;
}

export const CashOfferCard = ({
  headingId,
  headingClassName,
  children,
  media,
}: CashOfferCardProps) => (
  <Col
    as="section"
    aria-labelledby={headingId}
    className={cn(
      'gap-6 rounded-xl border border-od-border-primary bg-od-bg-secondary p-6',
      media && 'md:flex-row md:gap-0 md:p-0',
    )}
  >
    {media}
    <Col className={cn('min-w-0 flex-1 gap-6', media && 'md:p-6')}>
      <Col className="gap-3">
        <Text
          as="h2"
          id={headingId}
          className={cn('text-label-lg text-od-content-primary', headingClassName)}
        >
          Get a cash offer on your home
        </Text>
        <Text as="p" className="text-body-md text-od-content-secondary">
          See what your home is worth with a free, no-obligation offer.
        </Text>
      </Col>
      {children}
    </Col>
  </Col>
);
